<template>
  <section class="inventory--part-details animated fadeIn">
    <div class="list-group-item mb-2">
      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.reelInspection_Labels">
        <span class="col-form-label">Verify labels and placement</span>
      </b-form-radio-group>
      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.reelInspection_Size">
        <span class="col-form-label">Size of reel and material match specsheet</span>
      </b-form-radio-group>
      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.reelInspection_LeaderTape">
        <span class="col-form-label">Reel has proper leader tape</span>
      </b-form-radio-group>
      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.reelInspection_Count">
        <span class="col-form-label">Verify reel count and cover film</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Yes', 'No', 'N/A']"
        v-model="model.reelInspection_Orientation"
      >
        <span class="col-form-label">Part orientation in reel is consistent</span>
      </b-form-radio-group>
      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.reelInspection_Damage">
        <span class="col-form-label">Splices or cuts in tape</span>
      </b-form-radio-group>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {FIELDS}  from '../../constants'
export default {
  name: 'ideaReels',
  components: {},
  props: {
    inspectionDetails: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        reelInspection_Labels: this.inspectionDetails[FIELDS.REEL_INSPECTION__LABELS] || '',
        reelInspection_Size: this.inspectionDetails[FIELDS.REEL_INSPECTION__SIZE] || '',
        reelInspection_LeaderTape: this.inspectionDetails[FIELDS.REEL_INSPECTION__LEADER_TAPE] || '',
        reelInspection_Count: this.inspectionDetails[FIELDS.REEL_INSPECTION__COUNT] || '',
        reelInspection_Orientation: this.inspectionDetails[FIELDS.REEL_INSPECTION__ORIENTATION] || '',
        reelInspection_Damage: this.inspectionDetails[FIELDS.REEL_INSPECTION__DAMAGE] || '',
      },
    };
  },
  computed: {},
  mounted() {},
};
</script>